<template>
  <div class="projectPage">
    <Header
      :menuIndex="1"
      :banner="bannerImg"
      mainTitle="大西安岩土与地质环境综合信息系统"
      mainTitleColor="#fff"
      subTitle="大西安岩土与地质环境综合信息系统"
      subTitleColor="#fff"
    />
    <div class="navBar">
      <div class="container">
        <div
          class="item"
          v-for="(item, index) in navBarList"
          :key="index"
          :class="{ active: activeIndex == index }"
          @click="changeActiveIndex(index)"
        >
          {{ item }}
        </div>
      </div>
    </div>
    <div class="container" ref="sectionA">
      <section class="sectionA">
        <div class="sec-title">{{ navBarList[0] }}</div>
        <div class="content">
          <div class="item" v-for="(item, index) in sectionAList" :key="index">
            <img :src="item.img" alt="" />
            <div class="info">
              <div class="title">{{ item.title }}</div>
              <div class="desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <section class="sectionB" ref="sectionB">
      <div class="container">
        <div class="sec-title">{{ navBarList[1] }}</div>
        <div class="content">
          <div class="item" v-for="(item, index) in sectionBList" :key="index">
            <img :src="item.img" alt="" />
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </section>
    <div class="container" ref="sectionC">
      <section class="sectionC">
        <div class="sec-title">{{ navBarList[2] }}</div>
        <div class="sec-sub-title">
        以大西安地区为中心，向外扩展
        </div>
        <div class="content">
          <div class="tabs">
            <div
              class="item"
              :class="{ active: sectionCActiveIndex == index }"
              v-for="(item, index) in sectionCList"
              :key="index"
              @click="changeSectionC(index)"
            >
              <div class="tab" v-if="sectionCActiveIndex != index">
                {{ item.title }}
              </div>
              <div class="detail" v-if="sectionCActiveIndex == index">
                <div class="title">{{ item.title }}</div>
                <div class="desc">
                  <span v-for="(item_s, indes_s) in item.desc" :key="indes_s">{{
                    item_s
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <img :src="sectionCList[sectionCActiveIndex].img" alt="" />
        </div>
      </section>
    </div>
    <div class="contactus">
      <div class="title">从这里开始，让数据用起来</div>
      <div class="btn"  @click="$router.push('/application')">联系我们</div>
    </div>
    <Foot />
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      bannerImg: require("@/assets/banner/8.jpg"),
      navBarList: ["产品优势", "核心功能", "产品展示"],
      activeIndex: 0,
      sectionAList: [
        {
          img: require('@/assets/chanpinyoushi/1.png'),
          title: "全面的地质数据收录",
          desc: "大西安系统收集了大量可靠的地质数据，包括钻孔数量超过20000个和项目数量超过10000个，为用户提供全面的地质信息支持",
        },
        {
          img: require('@/assets/chanpinyoushi/2.png'),
          title: "丰富的专题图件",
          desc: "收录了西安地区的专题图件，如地貌图、湿陷性黄土分区图和地裂缝分布图等，使用户可以直观了解地质环境，支持科研和决策分析",
        },
        {
          img: require('@/assets/chanpinyoushi/3.png'),
          title: "多维度的项目和钻孔搜索",
          desc: "用户可以根据项目名称、经纬度坐标和平面坐标等多维度进行搜索和查询，方便快捷地获取项目信息和钻孔信息",
        },
        {
          img: require('@/assets/chanpinyoushi/4.png'),
          title: "数据上传和权限管理",
          desc: "支持用户上传数据，并根据权限设置进行数据查询，保护数据的安全性和机密性，使用户可以灵活管理和共享数据",
        },
        {
          img: require('@/assets/chanpinyoushi/5.png'),
          title: "不断增长的数据覆盖范围",
          desc: "随着勘察项目的实施，大西安系统的数据量不断增加，并且数据覆盖范围逐渐扩展到其他省市，为用户提供更广泛的地质信息资源",
        },
        {
          img: require('@/assets/chanpinyoushi/6.png'),
          title: "实用的地下水位和波速数据查询",
          desc: "提供地下水位查询和波速数据查询功能，用于抗浮水位提参和初步判断场地类别，为工程设计和决策提供有力支持",
        },
      ],
      sectionBList: [
        {
          img: require('@/assets/hexingongneng/1.png'),
          title: "多维度的搜索和查询功能",
          desc: "用户可以根据项目名称、经纬度坐标和平面坐标等多种方式进行搜索和查询，便捷地获取项目信息和钻孔数据，提高工作效率",
        },
        {
          img: require('@/assets/hexingongneng/2.png'),
          title: "地下水位和波速数据查询",
          desc: "提供地下水位查询和波速数据查询功能，用于抗浮水位提参和初步判断场地类别，为工程设计和地质研究提供重要参考",
        },
        {
          img: require('@/assets/hexingongneng/3.png'),
          title: "钻孔数据处理和分析",
          desc: "对钻孔数据进行处理和分析，包括数据解释、岩土层分析、地质描述、土层统计等，提供准确的地质信息和数据展示",
        },
        {
          img: require('@/assets/hexingongneng/4.png'),
          title: "地质图件制作与展示",
          desc: "生成各种地质图件，如地质剖面图、地质平面图、地质构造图等，用于展示和呈现地质情况和特征",
        },
        {
          img: require('@/assets/hexingongneng/5.png'),
          title: "勘察报告生成",
          desc: "根据用户输入的数据和要求，自动生成标准化的勘察报告，包括工程概况、勘察过程、地质描述、分析结果等内容",
        },
        {
          img: require('@/assets/hexingongneng/6.png'),
          title: "数据管理和存储",
          desc: "强大的数据管理和存储功能，能够有效管理和存储大量的岩土地质勘查数据，包括钻孔数据、地质图件、实验数据等",
        },
      ],
      sectionCList: [
        {
          title: "大西安综合信息系统",
          desc: ["有据可查", "展示、提取、查询、研究、管理"],
          img: require("@/assets/xian/show1.png"),
        },
        {
          title: "多种专题图件",
          desc: ["西安地貌图", "湿陷性黄土分区图", "西安地裂缝分布图"],
          img: require("@/assets/xian/show2.png"),
        },
        {
          title: "完整地貌图",
          desc: ["数据可视化", "数据可读性","地图、卫星图"],
          img: require("@/assets/xian/show3.png"),
        },
        {
          title: "地质信息",
          desc: ["记录详细", "真实可靠"],
          img: require("@/assets/xian/show4.png"),
        },
      ],
      sectionCActiveIndex: 0,
    };
  },
  mounted() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    const observer1 = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.activeIndex = 0;
        }
      });
    }, options);

    observer1.observe(this.$refs.sectionA);

    const observer2 = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.activeIndex = 1;
        }
      });
    }, options);

    observer2.observe(this.$refs.sectionB);

    const observer3 = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.activeIndex = 2;
        }
      });
    }, options);

    observer3.observe(this.$refs.sectionC);
  },
  methods: {
    changeActiveIndex(index) {
      this.activeIndex = index;
      switch (index) {
        case 0:
          this.$refs.sectionA.scrollIntoView({ behavior: "smooth" });
          break;
        case 1:
          this.$refs.sectionB.scrollIntoView({ behavior: "smooth" });
          break;
        case 2:
          this.$refs.sectionC.scrollIntoView({ behavior: "smooth" });
          break;
      }
    },
    changeSectionC(index) {
      this.sectionCActiveIndex = index;
    },
  },
};
</script>
  
<style lang="scss" scoped>
.container {
  width: 1280px;
  margin: 0 auto;
}
.projectPage {
  .navBar {
    height: 55px;
    position: sticky;
    z-index: 100;
    top: 0;
    background-color: #fff;
    box-shadow: 0 1px 1px 0 #ebedf6;
    > .container {
      display: flex;
      align-items: center;
      .item {
        cursor: pointer;
        margin-right: 50px;
        font-size: 16px;
        line-height: 55px;
        color: #7a8ba6;
        position: relative;
        &::after {
          content: "";
          width: 100%;
          height: 2px;
          background-image: linear-gradient(90deg, #659eff 0, #2466ff 100%);
          position: absolute;
          bottom: 0;
          left: 0;
          opacity: 0;
          transition: all 0.3s;
        }
      }
      .item.active {
        &::after {
          opacity: 1;
        }
      }
    }
  }
  section {
    .sec-title {
      font-size: 28px;
      font-weight: 500;
      line-height: 48px;
      color: #374567;
      text-align: center;
      width: 100%;
      padding-bottom: 72px;
      padding-top: 72px;
    }
  }
  .sectionA {
    padding-bottom: 72px;
    & > .content {
      display: grid;
      column-gap: 150px;
      row-gap: 70px;
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: 132px 132px;
      .item {
        display: flex;
        img {
          width: 30px;
          height: 30px;
          margin-right: 15px;
        }
        .info {
          .title {
            color: #374567;
            font-size: 18px;
            font-weight: 600;
            line-height: 32px;
          }
          .desc {
            margin-top: 16px;
            color: #7a8ba6;
            width: 100%;
            overflow: hidden;
            font-size: 14px;
            line-height: 24px;
            text-align: justify;
          }
        }
      }
    }
  }
  .sectionB {
    width: 100%;
    background-color: #f9faff;
    padding-bottom: 80px;
    .content {
      display: grid;
      column-gap: 25px;
      row-gap: 25px;
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-rows: 344px 344px;
      .item {
        position: relative;
        background-color: #fff;
        img {
          position: absolute;
          width: 148px;
          height: 148px;
          bottom: 5px;
          right: 14px;
        }
        .title {
          font-weight: 600;
          margin-left: 32px;
          margin-top: 32px;
          height: 32px;
          font-size: 18px;
          color: #374567;
          line-height: 32px;
          text-align: left;
        }
        .desc {
          margin-right: 32px;
          padding-top: 8px;
          margin-left: 32px;
          letter-spacing: 1.5px;
          font-size: 14px;
          text-align: justify;
          color: #7a8ba6;
          line-height: 24px;
        }
      }
    }
  }
  .sectionC {
    width: 100%;
    padding-bottom: 80px;
    .sec-title {
      font-size: 28px;
      font-weight: 500;
      line-height: 48px;
      color: #374567;
      text-align: center;
      padding: 70px 0 0 0;
    }
    .sec-sub-title {
      font-size: 14px;
      color: #7a8ba6;
      line-height: 24px;
      max-width: 1280px;
      margin: 24px auto 72px auto;
      text-align: center;
    }
    .content {
      width: 100%;
      .tabs {
        width: 100%;
        display: flex;
        background-color: #f9faff;
        .item {
          flex: 1;
          height: 136px;
          cursor: pointer;
          .tab {
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 18px;
            color: #374567;
            font-weight: 500;
            text-align: center;
          }
          .detail {
            .title {
              margin-top: 32px;
              margin-left: 24px;
              font-weight: 600;
              font-size: 18px;
              color: #374567;
              line-height: 24px;
              text-align: left;
              height: 24px;
              width: 352px;
            }
            .desc {
              margin-top: 10px;
              margin-left: 24px;
              font-size: 14px;
              color: #7a8ba6;
              line-height: 24px;
              span {
                margin-right: 12px;
              }
            }
          }
        }
        .item.active {
          width: 455px;
          height: 136px;
          border-top: 4px solid #2468ff;
          background-color: #fff;
        }
      }
      img {
        width: 100%;
        height: 720px;
      }
    }
  }
  .contactus {
    width: 100%;
    height: 180px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-image: linear-gradient(
      90deg,
      rgb(251, 252, 255),
      rgb(228, 234, 252) 75%,
      rgb(202, 222, 255)
    );
    .title {
      font-size: 30px;
      line-height: 40px;
      letter-spacing: 1.88px;
      text-align: center;
      color: #181818;
      padding-top: 49px;
      font-weight: 500;
    }
    .btn {
      margin-top: 20px;
      width: 108px;
      height: 36px;
      border-radius: 18px;
      background-image: linear-gradient(
        90deg,
        rgb(124, 172, 255),
        rgb(98, 140, 255)
      );
      margin: 20px auto;
      font-size: 14px;
      color: #fff;
      line-height: 36px;
      cursor: pointer;
      text-align: center;
      &:hover {
        background-image: linear-gradient(
          90deg,
          rgb(113, 165, 255),
          rgb(78, 125, 252)
        );
      }
    }
  }
}
</style>